// Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
// Components
import Icon from '../components/icon';
import Button from '../components/button';
// Actions
import setStep from '../actions/steps';
import toggleTimeline from '../actions/timeline';
import { setTheme } from '../actions/themes';
// Assets
import logo from '../../images/sprite/logo.svg';
import facebook from '../../images/sprite/facebook.svg';
import twitter from '../../images/sprite/twitter.svg';
// Misc
import {
  FACEBOOK_URL,
  TWITTER_URL
} from '../libs/get-social';

class Complete extends Component {
  componentWillMount() {
    const finalStep = this.props.steps.length - 1;
    this.props.dispatch(setStep(finalStep));
    this.props.dispatch(toggleTimeline(true));
    this.props.dispatch(setTheme('default'));
  }
  render() {
    return (
      <div className="view view--complete">
        <div className="complete">
          <p className="p--medium l-mb--xl">Diva or believer, Christmas is a time to do for others. NEVERBLAND will donate 10p to <a target="_blank" rel="noopener noreferrer" href="https://cafdonate.cafonline.org/294#/DonationDetails">Hackney Winter Night Shelter</a> for EVERY SHARE on Twitter and Facebook up to £1,000. Just by clicking the links below you can help make a difference for our most vulnerable brothers and sisters this Christmas.</p>
          <p className="p--medium l-mb--xl">For once, sharing really is caring.</p>
          <div className="l-button-group l-mb--m">
            <Button
              to={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon className="button__icon" glyph={facebook} />Share on Facebook
            </Button>
            <Button
              to={TWITTER_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon className="button__icon" glyph={twitter} />Share on twitter
            </Button>
          </div>
          <Button className="button--transparent" to="/questions">Play again</Button>
        </div>
        <footer className="footer"><a target="_blank" rel="noopener noreferrer" href="http://neverbland.com/careers">Join our team</a></footer>
      </div>
    );
  }
}

function mapStateToProps({ steps }) {
  return { steps };
}

export default connect(mapStateToProps)(Complete);



/** WEBPACK FOOTER **
 ** ./src/js/containers/complete.js
 **/